__turbopack_context__.v({
  "className": "-kuotq_className",
  "variable": "-kuotq_variable",
});
